// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--u6knr","description-wrapper":"_93444fe79c--description-wrapper--BCjRB"};